module.exports = __webpack_public_path__ + "static/media/Intersection 35.9b01110d.png";